import { DesignTokens, GivelifyLabel } from '@givelify/ui';
import { styled } from '@mui/material';

export const TimeLabel = styled(GivelifyLabel)({
    fontFamily: `${DesignTokens.font.areaNormalExtrabold}, sans-serif`,
    fontSize: '22px',
});
